export const name = '$gzError';
export default function $gzError($log, $mdDialog, $mdToast, $filter) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var service = {
    alert: doAlert,
    alertByLocalizationKey: alertByLocalizationKey,
    alertBySmsException: alertBySmsException,
    alertMessage: alertMessage
  };

  return service;

  /////////////////

  function doAlert(app, catalog, service,  errorCode, subCode, toast = false) {
    var message = $filter('translate')(app+ '.'+ catalog + '.'+ service + '_' +  errorCode + '_'+ subCode);
    return showErrorDialog(message);
  }

  function alertByLocalizationKey(localizationKey, toast = false) {
    var message = $filter('translate')(localizationKey);
    return showErrorDialog(message);
  }

  function alertBySmsException(exception, toast = false) {
    $log.info('exception: '+ JSON.stringify(exception));
    var message;
    if(exception === undefined  || exception.smsError === undefined || exception.smsError.message === undefined){
     message = $filter('translate')('uxf.uxf.GenericError');
    }else{
      message = exception.smsError.message;
    }

    return showErrorDialog(message);
  }

  function alertMessage(message, toast = false) {
    $log.warn('$gzError#alertMessage does not localize - use "alert" or "alertByLocalizationKey"');
    return showErrorDialog(message);
  }

  function showErrorDialog(message) {
    var ok = $filter('translate')('uxf.uxf.OK');
    var errorTitle = $filter('translate')('uxf.uxf.Error_Title');

    if(message.indexOf("L10N") > -1 ){
      message = $filter('translate')('uxf.uxf.GenericError');
    }

    return $mdDialog.show(
      $mdDialog.alert()
        .parent(angular.element(document.body))
        // .title(errorTitle)
        .textContent(message)
        .ariaLabel(errorTitle)
        .ok(ok)
    );
  }

  function showErrorToast(message) {
    if(message.indexOf("L10N") > -1 ){
      message = $filter('translate')('uxf.uxf.GenericError');
    }
    return $mdToast.showSimple(message);
  }
}
